import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';

@Component({
  selector: 'app-change-facility-filter',
  templateUrl: './change-facility-filter.component.html',
  styleUrls: ['./change-facility-filter.component.scss'],
})
export class ChangeFacilityFilterComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  private filterMode = false;

  public selectedRow: any;
  public changeFacilityFormGroup: FormGroup;

  constructor(public authService: AuthService) {
    this.changeFacilityFormGroup = new FormGroup({
      facility: new FormControl(''),
    });
  }

  ngOnInit() {
    this.changeFacilityFormGroup.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => this.authService.facilityDialogFilter$.next(data));

    this.authService.changeFacilityDialog$
      .pipe(
        filter((x) => !!x),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.resetForm());

    this.authService.changeFacilityFilterMode.pipe(takeUntil(this.destroy$)).subscribe((x) => (this.filterMode = x));
    this.authService.selectedFacilityRow$.pipe(takeUntil(this.destroy$)).subscribe((row) => (this.selectedRow = row));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  resetForm() {
    this.authService.facilityDialogFilter$.next(null);
    this.changeFacilityFormGroup.reset({
      facility: '',
    });
  }

  public goBack() {
    if (this.filterMode) {
      this.authService.changeFacilityDismissDialog.next(true);
      return;
    }

    this.authService.changeFacilityShowing.next('grid');
  }
}
